module.exports = __webpack_public_path__ + "static/media/fa-brands-400.13685372.ttf";